<template>
  <div
    ref="stepPoint"
    :id="pointId"
    class="stepPoint"
  >
    <div class="pointStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'LandingStepPoint',

  props: {
    pointIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      pointId: 'stepPoint_' + this.pointIndex,
    };
  },

  methods: {
    setColor(color) {
      let stepPointRef = this.$refs['stepPoint'];
      stepPointRef.style.background = color;
    },
  },
};
</script>
